import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Tooltip from 'components/tooltip';

import './styles.scss';

export default function ClickableIcon({ className, icon, size, tooltip, onClick }) {
  let content = <FontAwesomeIcon icon={icon} size={size} />;
  if (tooltip) {
    content = (
      <Tooltip content={tooltip}>
        {content}
      </Tooltip>
    );
  }

  return (
    <div className={classNames('clickable-icon', className, size)} onClick={onClick}>
      {content}
    </div>
  );
}

ClickableIcon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.object.isRequired,
  size: PropTypes.string,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
};
